module.exports = __webpack_public_path__ + "8be5705706405aaff029fe0c0be722ad.svg";